import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import MessageDispatcherService from '../services/MessageDispatcherService';
import { isOriginAllowed } from '../functions/allowedOrigins';
import { TARGET_PARAM, PARAMS_TO_REPORT } from '../constants/searchParams';
import Page from '../../router/pages';

/** Reports the current route to the embedding host so it can mirror its URL. */
export function useReportRoute() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // This app always runs inside an allow-listed host.
    if (window.parent === window) {
      return;
    }

    const currentParams = new URLSearchParams(search);
    const target = currentParams.get(TARGET_PARAM);

    if (!target || !isOriginAllowed(target)) {
      return;
    }

    // Verify reported page rather than trusting that
    // the router only ever produces known paths.
    const authPages: string[] = Object.values(Page);

    if (!authPages.includes(pathname)) {
      return;
    }

    const paramsToReport = new URLSearchParams();

    PARAMS_TO_REPORT.forEach((name) => {
      const value = currentParams.get(name);

      if (value !== null) {
        paramsToReport.set(name, value);
      }
    });

    new MessageDispatcherService(target).sendRouteChangeMessage({
      page: pathname.replace(/^\//, ''),
      search: paramsToReport.toString(),
    });
  }, [pathname, search]);
}
